import { useQuery } from '@tanstack/react-query';

import { fetchAccessRights } from 'apis/restaurant-api/merchant-admin/user/api';

export const useAccessRights = (isEnabled: boolean) => {
  const {
    data: accessRights,
    error,
    isLoading: isLoadingQuery,
    isFetching: isFetchingQuery,
  } = useQuery(
    ['/v2/merchant-admin/access'],
    () => {
      return fetchAccessRights();
    },
    {
      enabled: isEnabled,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: false,
    },
  );

  const isLoading = isEnabled ? isLoadingQuery && isFetchingQuery : false;

  return { accessRights, error, isLoading };
};
